import React, { useEffect, useState } from 'react';
import { Container, Card, Button, Modal, Row, Alert, Spinner } from 'react-bootstrap';
import PlanService from '../../service/PlanService';
import EmailService from '../../service/EmailService';
import SlimAd from '../../assets/diamond-slim-ad.webp';
import DiamondAd from '../../assets/diamond_ad.webp';
import GoldAd from '../../assets/gold_ad.webp';
import SilverAd from '../../assets/silver_ad.webp';
import FreeAd from '../../assets/free_ad.webp';

const Plans = () => {
  // Image Modal State
  const [showImageModal, setShowImageModal] = useState(false);
  const [planImage, setPlanImage] = useState(null);

  // Plans Data
  const [plans, setPlans] = useState([]);

  // Quote Modal
  const [showModal, setShowModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  // Form State
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    formMessage: ''
  });

  const [message, setMessage] = useState({ text: '', variant: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await PlanService.getAllPlans();
      setPlans(response);
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };

  // Quote Modal Open
  const handleShow = (planName) => {
    setSelectedPlan(planName);
    setShowModal(true);
  };

  // Quote Modal Close
  const handleClose = () => setShowModal(false);

  // Image popup open
  const handleShowImage = (img, planName) => {
    setSelectedPlan(planName);
    setPlanImage(img);
    setShowImageModal(true);
  };

  const handleCloseImage = () => setShowImageModal(false);

  // Form Change Handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: '', variant: '' });

    try {
      const response = await EmailService.sendEmail(formData);
      setMessage({ text: response, variant: 'success' });

      setFormData({ name: '', email: '', phone: '', formMessage: '' });
    } catch (error) {
      setMessage({ text: `Error: ${error.message}`, variant: 'danger' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="plan-section">
        <Container>
          <Row>
            <div className="plan_title">
              <h2 className="text-center">Easily Find the Right Plan Designed Just for You</h2>
              <p className="text-center">
                Pick the ideal plan that suits your needs. Enjoy the flexibility of choosing between <br />
                monthly or yearly subscriptions.
              </p>
            </div>
          </Row>

          {/* NEW Plan Layout */}
              <div className='row align-items-end justify-content-center modified_plan'>
                {/* Left Column Features */}
                <div className='col-md-3 px-md-0 px-3 d-md-block d-none'>
                  <div className='mp_description text-left'>
                    <h4 className='mp_title'>Pick Your Plan</h4>
                    <p>Choose a plan that works best for your needs.</p>
                  </div>
                  <div className='mp_description_list text-left'>
                    <ul>
                      <li>Image Display</li>
                      <li>Distance Visibility</li>
                      <li>Company Name</li>
                      <li>Business Address</li>
                      <li>Email</li>
                      <li>Phone</li>
                      <li>Services Display</li>
                      <li className='text-white'>Plans Demo</li>
                    </ul>
                  </div>
                </div>

                {/* FREE PLAN */}
                <div className='col-md-2 px-md-0 px-3'>
                  <div className='mp_description'>
                    <h4>Free Plan</h4>
                    <h5 className='mp_price'>$25</h5>
                    <h6 className='mp_month'>Per Month</h6>
                    <Button className='mp_button' onClick={() => handleShow('Free')}>
                      Get Started
                    </Button>
                  </div>

                  <div className='mp_description_list'>
                    <ul>
                      <li><i className="fas fa-times"></i> <p>Image Display</p></li>
                      <li><i className="fa fa-check"></i> <p>Distance Visibility</p></li>
                      <li><i className="fa fa-check"></i> <p>Company Name</p></li>
                      <li><i className="fa fa-check"></i> <p>Business Address</p></li>
                      <li><i className="fa fa-check"></i> <p>Email</p></li>
                      <li><i className="fa fa-check"></i> <p>Phone</p></li>
                      <li><i className="fa fa-check"></i> <p>Services Display</p></li>
                      <li>
                        <a onClick={() => handleShowImage(FreeAd, "Free Plan")} className="plan_link" style={{ cursor: "pointer" }}>
                          View Demo
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* DIAMOND PLAN */}
                <div className='col-lg-2 col-md-3 px-md-0 px-3'>
                  <div className='mp_description mp_active'>
                    <h4>Diamond Plan</h4>
                    <h5 className='mp_price'>$100</h5>
                    <h6 className='mp_month'>Per Month</h6>
                    <Button className='mp_button' onClick={() => handleShow('Diamond')}>
                      Get Started
                    </Button>
                  </div>

                  <div className='mp_description_list'>
                    <ul>
                      <li><span>Large (550X600px)</span> <p>Image Display</p> </li>
                      <li><i className="fa fa-check"></i> <p>Distance Visibility</p> </li>
                      <li><i className="fa fa-check"></i> <p>Company Name</p> </li>
                      <li><i className="fa fa-check"></i> <p>Business Address</p> </li>
                      <li><i className="fa fa-check"></i> <p>Email</p> </li>
                      <li><i className="fa fa-check"></i> <p>Phone</p> </li>
                      <li><i className="fa fa-check"></i> <p>Services Display</p> </li>
                      <li>
                        <a onClick={() => handleShowImage(DiamondAd, "Diamond Plan")} className="plan_link" style={{ cursor: "pointer" }}>
                          View Demo
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* GOLD PLAN */}
                <div className='col-md-2 px-md-0 px-3'>
                  <div className='mp_description'>
                    <h4>Gold Plan</h4>
                    <h5 className='mp_price'>$75</h5>
                    <h6 className='mp_month'>Per Month</h6>
                    <Button className='mp_button' onClick={() => handleShow('Gold')}>
                      Get Started
                    </Button>
                  </div>
                  <div className='mp_description_list'>
                    <ul>
                      <li><span>Medium (550X400px)</span> <p>Image Display</p> </li>
                      <li><i className="fa fa-check"></i> <p>Distance Visibility</p> </li>
                      <li><i className="fa fa-check"></i> <p>Company Name</p> </li>
                      <li><i className="fa fa-check"></i> <p>Business Address</p> </li>
                      <li><i className="fa fa-check"></i> <p>Email</p> </li>
                      <li><i className="fa fa-check"></i> <p>Phone</p> </li>
                      <li><i className="fa fa-check"></i> <p>Services Display</p> </li>
                      <li>
                        <a onClick={() => handleShowImage(GoldAd, "Gold Plan")} className="plan_link" style={{ cursor: "pointer" }}>
                          View Demo
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* SILVER PLAN */}
                <div className='col-md-2 px-md-0 px-3'>
                  <div className='mp_description'>
                    <h4>Silver Plan</h4>
                    <h5 className='mp_price'>$50</h5>
                    <h6 className='mp_month'>Per Month</h6>
                    <Button className='mp_button' onClick={() => handleShow('Silver')}>
                      Get Started
                    </Button>
                  </div>
                  <div className='mp_description_list'>
                    <ul>
                      <li><span>Small (550X250px)</span> <p>Image Display</p> </li>
                      <li><i className="fa fa-check"></i> <p>Distance Visibility</p> </li>
                      <li><i className="fa fa-check"></i> <p>Company Name</p> </li>
                      <li><i className="fa fa-check"></i> <p>Business Address</p> </li>
                      <li><i className="fa fa-check"></i> <p>Email</p> </li>
                      <li><i className="fa fa-check"></i> <p>Phone</p> </li>
                      <li><i className="fa fa-check"></i> <p>Services Display</p> </li>
                      <li>
                        <a onClick={() => handleShowImage(SilverAd, "Silver Plan")} className="plan_link" style={{ cursor: "pointer" }}>
                          View Demo
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>

          {/* QUOTE MODAL */}
          <Modal className='quote_modal' show={showModal} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Get A Quote</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className='form_content'>
                <p className='mb-4'>
                  Thank you for your interest in our <strong>{selectedPlan}  Plan</strong>.
                  We’re thrilled to assist you!
                </p>
              </div>

              <form onSubmit={handleSubmit}>
                <Row>
                  <div className="col-md-6">
                    <div className="form-group cont_form">
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Your Name"
                        required
                        disabled={loading}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group cont_form">
                      <input
                        type="tel"
                        className="form-control"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="Phone"
                        required
                        disabled={loading}
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-group cont_form">
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Email"
                        required
                        disabled={loading}
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-group cont_form">
                      <textarea
                        className="form-control h-auto"
                        rows="3"
                        name="formMessage"
                        value={formData.formMessage}
                        onChange={handleChange}
                        placeholder="Write a message"
                        required
                        disabled={loading}
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    {message.text && (
                      <Alert variant={message.variant} className="mt-0 py-2 text-center">
                        {message.text}
                      </Alert>
                    )}

                    <div className="form_btn mt-1">
                      <button type="submit" className="btn w-100" disabled={loading}>
                        {loading ? (
                          <>
                            <Spinner animation="border" size="sm" className="me-2" /> Sending...
                          </>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </div>
                </Row>
              </form>
            </Modal.Body>
          </Modal>

          {/* IMAGE POPUP MODAL */}
          <Modal className='demo_image_modal' show={showImageModal} onHide={handleCloseImage} size="xl" centered>
            <Modal.Header closeButton>
              <Modal.Title>{selectedPlan}</Modal.Title>
            </Modal.Header>

            <Modal.Body className='p-0'>
              {planImage && (
                <img
                  src={planImage}
                  alt="Plan Preview"
                  style={{ maxWidth: "100%", borderRadius: "10px" }}
                />
              )}
            </Modal.Body>
          </Modal>

        </Container>
      </section>
    </>
  );
};

export default Plans;
